(function($) {
  'use strict';

  const themes = {
    slider: undefined,

    slides: {},

    dom: function() {
      this.$slider = $('[data-themes]');
      this.$prev = $('.js-themes-prev');
      this.$next = $('.js-themes-next');
    },

    sliderInit: function() {
      this.$slider.on('init', function(event, slick){
        slick.$slides.each(function(index) {
          let id = $(this).find('.themes__item').attr('id');
          themes.slides[id] = index;
        });
        themes.firstSlide(slick);
      });

      this.$slider.on('afterChange', function(event, slick, currentSlide) {
        themes.changeHash(slick, currentSlide);
      });

      themes.slider = this.$slider.slick({
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        fade: true,
        speed: 500,
        responsive: [
          {
            breakpoint: jcms.breakpoints.small,
            settings: {
              centerMode: true,
              centerPadding: 'var(--gutter)',
              dots: false,
              fade: false
            }
          }
        ]
      });
    },

    slideOut: function(callback) {
      let $currentSlide = themes.slider.find('.slick-current');
      let $wrap = $currentSlide.find('.themes__wrap');
      let $swipe = $currentSlide.find('.themes__image-swipe');

      $swipe.animate({
        'width': '100%',
        'height': '100%'
      }, 200, function() {
        setTimeout(function() {
          callback();
          setTimeout(function() {
            $wrap.css('display','');
            $swipe.css({'width':'', 'height':''});
          }, 300);
        }, 400);
      });
    },

    sliderNav: function() {
      themes.$prev.click(function(event) {
        event.preventDefault();
        themes.slideOut(function() {
          themes.slider.slick('slickPrev');
        });
      });

      themes.$next.click(function(event) {
        event.preventDefault();
        themes.slideOut(function() {
          themes.slider.slick('slickNext');
        });
      });
    },

    firstSlide: function(slick) {
      if (typeof slick === 'undefined') {
        slick = themes.slider.slick('getSlick');
      }

      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        const slideId = themes.slides[hash];
        if (typeof slideId === 'number') {
          setTimeout(function() {
            themes.slider.slick('slickGoTo', slideId);
            }, 400);
        }
      }
      else {
        themes.changeHash(slick, 0);
      }
    },

    changeHash: function(slick, currentSlide) {
      const id = $(slick.$slides[currentSlide]).find('.themes__item').attr('id');
      if (typeof id !== 'undefined' && id.length) {
        history.pushState({}, "", "#" + id)
      }
    },

    ready: function() {
      this.dom();
      this.sliderInit();
      this.sliderNav();

      addEventListener("popstate", function (e) {
        console.log('popstate');
        themes.firstSlide();
      });
    }
  };

  $(function() { themes.ready(); });

})(jQuery);
